String.prototype.capitalize = function() {
  return this.toLowerCase().replace(/(?:^|\s)\S/g, function(a) {return a.toUpperCase();});
};
String.prototype.contains = function(s, substr) {
  return s.indexOf(substr) != -1;
};
String.prototype.removeAllSpaces = function() {
  return this.replace(/\s+/g, '');
};
String.prototype.trim = function() {
  return this.replace(/^\s+|\s+$/gm,'');
};
String.prototype.toCamelCase = function() {
  return this.toLowerCase().replace(/^([A-Z])|[\s-]+(\w)/g, 
    function(match, p1, p2, offset) {
      if (p2) return p2.toUpperCase();
      return p1.toLowerCase();        
  });
};

Number.prototype.toThousandCommaString = function(precision) {
  if (precision===null || precision===undefined) {
    precision = 2;
  }
  return this.toFixed(precision).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

Date.prototype.toISOStringWithTimeZone = function() {
  let yyyy = this.getFullYear();
  let MM = ('0' + (this.getMonth() + 1)).slice(-2);
  let dd = ('0' + this.getDate()).slice(-2);
  let hh = ('0' + this.getHours()).slice(-2);
  let mm = ('0' + this.getMinutes()).slice(-2);
  let ss = ('0' + this.getSeconds()).slice(-2);
  return yyyy + '-' + MM + '-' + dd + 'T' + hh + ':' + mm + ':' + ss;
}

Date.prototype.toISODateString = function() {
  let yyyy = this.getFullYear();
  let MM = ('0' + (this.getMonth() + 1)).slice(-2);
  let dd = ('0' + this.getDate()).slice(-2);
  return yyyy + '-' + MM + '-' + dd;
}
